import { render, staticRenderFns } from "./ToolBox.vue?vue&type=template&id=270ccec4&scoped=true"
import script from "./ToolBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToolBox.vue?vue&type=style&index=0&id=270ccec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270ccec4",
  null
  
)

export default component.exports